module.exports = __webpack_public_path__ + "static/img/TaskControl.ff680fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/TaskControl.png
// module id = ekIK
// module chunks = 1